import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/services";

const SERVICES = [
  {
    id: "exterior",
    title: "Exterior Hand Wash",
    text: "Complete outside foam wash, hand dried with clean microfiber towels — wheels, tires, jambs and glass detailed.",
    image: IMAGES.exterior,
    to: "/packages",
  },
  {
    id: "interior",
    title: "Interior Detailing",
    text: "Involves a deep cleaning of the whole interior — vacuum, shampoo, leather care, vents, cup holders and glass.",
    image: IMAGES.interior,
    to: "/packages",
  },
  {
    id: "polishing",
    title: "Polishing",
    text: "Machine polishing that brings back deep gloss and removes light swirls, haze and oxidation.",
    image: IMAGES.ceramic,
    to: "/packages",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-16 md:py-24 bg-[#0E0E11]">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {SERVICES.map((s) => (
          <article
            key={s.id}
            data-testid={`service-card-${s.id}`}
            className="group relative overflow-hidden min-h-[400px] flex items-end"
          >
            <img
              src={s.image}
              alt={s.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/50 to-transparent" />
            <div className="relative p-6 sm:p-7">
              <h3 className="font-display uppercase font-semibold text-2xl tracking-wide text-white">{s.title}</h3>
              <p className="mt-2.5 text-sm text-slate-300 leading-relaxed">{s.text}…</p>
              <Link
                to={s.to}
                data-testid={`service-more-${s.id}`}
                className="mt-4 inline-flex items-center gap-2 font-display uppercase text-xs font-medium tracking-[0.15em] text-[#FF4311] hover:gap-3 transition-all"
              >
                Read More <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
